<template lang="pug">
.form-size.center(:class="{'inside-padding': !fillData}")
  form(@submit.prevent="" autocomplete="off")
    h2.title {{ title }}
    .form-section
      .input-container
        input.input(v-model="dataForm.size" autocomplete="ño" :disabled="fillData" required)
        label.label(:class="{ show: dataForm.size }")
          shProperty(:dataOriginal="dataOriginal" :dataForm="dataForm" property="size" title="Talla")

      .input-container
        input.input(v-model.number="dataForm.order" type="number" autocomplete="ño" required)
        label.label(:class="{ show: Number.isInteger(dataForm.order) }")
          shProperty(:dataOriginal="dataOriginal" :dataForm="dataForm" property="order" title="Orden")

      .left
        h3 Activo en Marca

      .input-container.arrow(v-for="(brand, index) in brands")
        select.select(v-model="dataForm.activeSize[index]" autocomplete="ño" required)
          option(:value="true") Activo
          option(:value="false") Inactivo
        label.label(:class="{ show: dataForm.activeSize[index] }")
          shProperty(:dataOriginal="dataOriginal" :dataForm="dataForm" property="activeSize" :index="index" :title="brand")

    shActionButton(:isForm="true" :text="fillData ? 'Actualizar' : 'Guardar'" :textRunning="fillData ? 'Actualizando' : 'Guardando'" :action="sendForm")

  .right(v-if="fillData")
      shDeleteButton(@delete="deleteSize")
</template>

<script>
import mForm from '@/mixins/form'
import mFilters from '@/mixins/filters'
import mDB from '@/mixins/db'
import gqlSize from '@/graphql/size'
import shDeleteButton from '@/components/elements/DeleteButton'

export default {
  name: 'FormSize',

  mixins: [mForm, mFilters, mDB],

  components: { shDeleteButton },

  props: {
    title: String,
    fillData: Boolean,
    dataOriginal: Object
  },

  data () {
    return {
      dataForm: {
        size: '',
        order: '',
        activeBrands: [],
        activeSize: []
      },
      resolver: 'size',
      key: 'size',
      gql: gqlSize
    }
  },

  created () {
    if (this.fillData) this.dataForm = this.copyObject(this.dataOriginal)
  },

  mounted () {
    this.dataForm.activeBrands = this.brands
  },

  methods: {
    sendForm () {
      if (!this.fillData) {
        this.newSize()
      } else {
        this.updateSize()
      }
    },

    newSize () {
      this.newData(this.gql, this.resolver, this.key)
    },

    updateSize () {
      this.updateData(this.gql, this.resolver, this.key)
    },

    deleteSize () {
      this.deleteData(this.gql, this.resolver, this.key)
    }
  },

  computed: {
    brands () {
      return this.$store.state.variables.brands
    }
  },

  watch: {
    dataOriginal: {
      handler (val) {
        if (this.fillData) this.dataForm = this.copyObject(this.dataOriginal)
      },
      deep: true
    }
  }
}
</script>

<style lang="stylus">
.form-size
  position relative
</style>



// WEBPACK FOOTER //
// src/components/pages/size/Form.vue